/**
 * Forms components index file
 * Exports all form components from the forms directory
 */

// Import form components
import LitGroupProfileForm from './LitGroupProfileForm';
import BookForm from './BookForm';
import BookFormEnh from './BookForm-enh';
import CharacterForm from './CharacterForm';
import CharacterFormEnh from './CharacterForm-enh';
import VariationForm_upgrade from './VariationForm_upgrade';
import VariationFormPanel from './VariationFormPanel';

// Export form components
export {
  LitGroupProfileForm,
  BookForm,
  BookFormEnh,
  CharacterForm,
  CharacterFormEnh,
  VariationForm_upgrade,
  // VariationFormEnh,
  VariationFormPanel
};

// Export default
export default {
  LitGroupProfileForm,
  BookForm,
  BookFormEnh,
  CharacterForm,
  CharacterFormEnh,
  VariationForm_upgrade,
  // VariationFormEnh,
  VariationFormPanel
};
